
<script>
    import { TOKEN_SESSION, USER, TOAST_MESSAGE} from '../../stores'
    import { onMount } from 'svelte';
    import CrudButtons from "./CrudButtons.svelte";
    import GLOBALS from "../../globals/GLOBALS";

    let listas = []
    let detalleLista = []
    let lis_tipo_selected = null

    onMount(async () => {
        await _getListas()
    })

    const _getListas = async () => {
        await _SERVER_QUERY('LISTAS','GETLISTAS')
        .then( json => { 
            var listas_tmp = json.data
            for (var index=0; index<listas_tmp.length; index++){
                listas_tmp[index].selected = false
            }
            listas = listas_tmp
        } )
        .catch( error => console.log(error) )
    }

    const _handleClickLista = async (lis_tipo) => {
        var data = { lis_tipo }
        await _SERVER_QUERY('LISTAS','GETDETALLE',data)
        .then( json => { 
            listas.map(( item, index) => {
                listas[index].selected = item.lis_tipo === lis_tipo ? true : false
            })
            newRecord.lis_descripcion = ""
            detalleLista = json.data
            lis_tipo_selected = lis_tipo
        } )
        .catch( error => console.log(error) )
    }

    let newRecord  = {
        lis_id      : 0,
        lis_tipo    : "",
        lis_descripcion  : null,
        lis_last_update  : null,
        lis_usu_update : $USER.usu_id
    }

    const _handleCRUDAction = async ( index, action ) => {
        newRecord.lis_tipo    = detalleLista[index].lis_tipo
        newRecord.lis_usu_update = $USER.usu_id
        
        const { opcion } = action.detail
        switch( opcion ) {
            case "CREATE" :
                await _SERVER_QUERY('LISTAS','CREATE', newRecord).then( async json => await _handleClickLista(lis_tipo_selected)).catch( json => console.log(json))
            break
            case "UPDATE" :
                detalleLista[index].lis_usu_update = $USER.usu_id
                await _SERVER_QUERY('LISTAS','UPDATE', detalleLista[index]).then( async json => await _handleClickLista(lis_tipo_selected)).catch( json => console.log(json))
            break
            case "DELETE" :
                detalleLista[index].lis_usu_update = $USER.usu_id
                await _SERVER_QUERY('LISTAS','DELETE', detalleLista[index]).then( async json => await _handleClickLista(lis_tipo_selected)).catch( json => console.log(json))
            break
        }
    }

    const _SERVER_QUERY = ( OPCION, ACTION, data ) => new Promise (async (resolve, reject) => {
        const URL = GLOBALS.URL;
        const bearer = "Bearer " + $TOKEN_SESSION;
        await fetch(`${URL}/API/configuraciones/${OPCION}/${ACTION}`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                Authorization: bearer,
                "Content-type": "application/json;charset=UTF-8",
            },
        })
        // Handle success
        .then((response) => response.json()) // convert to json
        .then((json) => {
            if (json.result === "success") {
                switch(`${OPCION}/${ACTION}`){
                    case "LISTAS/GETLISTAS":
                    case "LISTAS/GETDETALLE":
                        if (json.result === "success") {
                            resolve(json)
                        }else{
                            reject(json)
                        }
                    break
                    case "LISTAS/CREATE":
                    case "LISTAS/UPDATE":
                    case "LISTAS/DELETE":
                        if (json.result === "success") {
                            resolve(json)
                        }else{
                            reject(json)
                        }
                        TOAST_MESSAGE.set(json)
                    break;
                }
                return
            }else{
                TOAST_MESSAGE.set(json)
                reject({result:"error",message:`Hubo un error en ${OPCION}/${ACTION}`, data:[]})
                if (json.status === 403) TOKEN_SESSION.set(null)
            }
            
        }) //print data to console
        .catch((err) => reject({result:"error",message:`Hubo un error en ${err}`, data:[]})); // Catch errors
    })
</script>

<div class="main">
    <div class="flex-column justify-content-start pt-2">
        <div class="d-flex direction-row justify-content-between">
            <h4>Mantenimiento de Listas Desplegables</h4>
        </div>
        <div class="d-flex flex-row justify-content-between">
            <div class="lista-container p-3">
                <ul class="ul-listas">
                    {#each listas as item}
                        <!-- content here -->
                        <li class:selected={item.selected} on:click={_handleClickLista(item.lis_tipo)}>{item.lis_tipo}</li>
                    {/each}
                </ul>
            </div>
            <div class="lista-opc-container p-3">
                {#if detalleLista.length > 0}
                     <!-- content here -->
                    <p>
                        Puedes agregar nuevos valores a la lista. Así mismo, puedes editar únicamente su descripción. Ten en cuenta que el valor que se asocia en las diferentes tablas de la aplicación es el código y no la descripción. No es posible eliminar valores de lista que estás usando en otras tablas.
                    </p>
                    {#each detalleLista as item, index (item.lis_id)}
                        <div class="d-flex flex-row justify-content-start">
                            <div class="form-floating mb-1 ms-1 "><input length=100 disabled="true" bind:value={detalleLista[index].lis_id}  type="text" class="form-control" id="lis_id"  placeholder="Código" > <label for="lis_id">Código</label></div>
                            <div class="form-floating mb-1 ms-1 "><input length=100 disabled="" style="width:33em" bind:value={detalleLista[index].lis_descripcion}  type="text" class="form-control" id="lis_descripcion"  placeholder="Descripción" > <label for="lis_descripcion">Descripción</label></div>
                            <div class="form-floating mb-1 ms-1 "><input length=100 disabled="true" bind:value={detalleLista[index].lis_last_update} type="text" class="form-control" id="lis_last_update" placeholder="Fecha Actualización" > <label for="lis_last_update">Fecha Actualización</label></div>
                            <div class="form-floating mb-1 ms-1 "><input length=100 disabled="true" bind:value={detalleLista[index].lis_usu_update} type="text" class="form-control" id="lis_usu_update" lis_usu_update="Usuario" > <label for="lis_usu_update">Usuario</label></div>
                            <div class="form-floating mb-1 ms-1 d-flex align-items-center"><CrudButtons on:click={(action) => _handleCRUDAction( index,action )} nuevo={false} guardar={true} eliminar={true}/></div>
                        </div>
                    {/each}
                    <div class="d-flex flex-row justify-content-start">
                        <div class="form-floating mb-1 ms-1 "><input length=100 disabled="true" bind:value={newRecord.lis_id}  type="text" class="form-control" id="lis_id"  placeholder="Código" > <label for="lis_id">Código</label></div>
                        <div class="form-floating mb-1 ms-1 "><input length=100 disabled="" style="width:33em;background-color:#e74c3c3d" bind:value={newRecord.lis_descripcion}  type="text" class="form-control" id="lis_descripcion"  placeholder="Descripción" > <label style="color:#e74c3c" for="lis_descripcion">Descripción</label></div>
                        <div class="form-floating mb-1 ms-1 "><input length=100 disabled="true" bind:value={newRecord.lis_last_update} type="text" class="form-control" id="lis_last_update" placeholder="Fecha Actualización" > <label for="lis_last_update">Fecha Actualización</label></div>
                        <div class="form-floating mb-1 ms-1 "><input length=100 disabled="true" bind:value={newRecord.lis_usu_update} type="text" class="form-control" id="lis_usu_update" lis_usu_update="Usuario" > <label for="lis_usu_update">Usuario</label></div>
                        <div class="form-floating mb-1 ms-1 d-flex align-items-center"><CrudButtons on:click={(action) => _handleCRUDAction( 0,action )} nuevo={true} guardar={false} eliminar={false}/></div>
                    </div>
                {/if}
            </div>
        </div>
    </div>
</div>

<style>
    .main {
        margin-bottom: 52px;
    }  
    
    .ul-listas  {
        list-style: none;
        padding:0;
        margin:0;
    }

    .ul-listas > li {
        padding: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        position: relative;
        margin:20px;
        transition: all 250ms ease;
    }
    
    .ul-listas > li.selected {
        background-color: #ffc10722;
        color: rgb(123, 80, 16);
    }

    .ul-listas > li::before {
        content: "";
        position:absolute;
        top:50%;left:50%;
        background-color: #ffc10755;
        width:0%;
        height:0%;
        border-radius: 5px;
        transition: all 250ms ease;
    }

    .ul-listas > li:hover::before {
        height:100%;
        width:100%;
        top: 0%;
        left:0%;
    }


    .ul-listas > li::after {
        content: "";
        width: 80%;
        height: 1px;
        background-color: #ffc107;
        position: absolute;
        bottom: -10px;
    }

    .ul-listas > li:last-child::after{
        display: none;
    }

    .ul-listas > li:active {
        transform: scale(0.8);
    }

</style>
